import * as ActionCreators from './action-creators';
import { AsyncAction, BankAccountView } from 'models';
import services from 'services';

export const fetchInvestorBankAccounts = (coopId: string): AsyncAction => {
  return async (dispatch) => {
    dispatch(ActionCreators.requestInvestorBankAccounts());

    try {
      const bankAccounts: BankAccountView[] = (
        await services.get(`/api/portfolios/${coopId}/bank-accounts`)
      ).data.Data;

      dispatch(ActionCreators.requestInvestorBankAccountsSuccess(bankAccounts));
    } catch (err) {
      console.error(err);
      dispatch(ActionCreators.requestInvestorBankAccountsFailed());
    }
  };
};
